if(!customElements.get('staple-personalization'))customElements.define('staple-personalization',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.reusable==='true'){window.StapleBlanketFields?.attach(this);return}
    if(this.ready)return;this.ready=true;
    this.nameInput=this.querySelector('[data-name-input]');
    this.error=this.querySelector('[data-personalization-error]');
    this.counter=this.querySelector('[data-name-count]');
    this.addEventListener('change',e=>{if(e.target.type==='radio')this.syncChoice();this.clearError();this.updateCount()});
    this.addEventListener('input',()=>{this.clearError();this.updateCount()});
    this.syncChoice();this.updateCount();
    window.addEventListener('pageshow',()=>{const form=this.closest('product-form');if(form)delete form.dataset.stapleSubmitting});
  }
  disconnectedCallback(){if(this.dataset.reusable==='true'){this.blanketController?.disconnect();delete this.blanketController}}
  normalizedName(){return this.nameInput.value.normalize('NFC').replace(/\s+/gu,' ').trim()}
  updateCount(){this.counter.textContent=Array.from(this.normalizedName()).length+' / 25 characters'}
  syncChoice(){
    if(this.dataset.mode!=='name')return;
    const add=this.querySelector('input[type=radio]:checked')?.value==='name';
    this.querySelector('[data-name-panel]').hidden=!add;
    this.nameInput.disabled=!add;this.nameInput.required=add;
    if(!add){this.nameInput.value='';this.clearError();this.updateCount()}
  }
  clearError(){this.error.hidden=true;this.error.textContent='';this.querySelectorAll('[aria-invalid]').forEach(input=>input.removeAttribute('aria-invalid'))}
  fail(input,message){
    this.error.textContent=message;this.error.hidden=false;input.setAttribute('aria-invalid','true');
    input.scrollIntoView({block:'center',behavior:'smooth'});input.focus({preventScroll:true});return false;
  }
  validate(){
    if(this.dataset.reusable==='true')return this.blanketController?.validate()===true;
    this.clearError();this.syncChoice();
    if(this.dataset.mode==='name'&&this.nameInput.disabled)return true;
    const value=this.normalizedName();
    if(!value)return this.fail(this.nameInput,this.dataset.mode==='photo'?'Please enter the grandchild’s name.':'Please enter the recipient’s name, or choose No name.');
    if(Array.from(value).length>25)return this.fail(this.nameInput,'Please use 25 characters or fewer for the name.');
    if(/[\u0000-\u001f\u007f]/u.test(value))return this.fail(this.nameInput,'Please enter a name without control characters.');
    this.nameInput.value=value;this.updateCount();
    if(this.dataset.mode==='photo'){
      const year=this.querySelector('[data-year-input]'),photo=this.querySelector('[data-photo-input]');
      year.value=year.value.trim();
      if(!/^[0-9]{4}$/.test(year.value))return this.fail(year,'Please enter the Christmas year using four digits.');
      const file=photo.files?.[0];
      if(!file)return this.fail(photo,'Please choose a photo for your blanket.');
      const validType=['image/jpeg','image/png','image/webp'].includes(file.type)||(!file.type&&/\.(jpe?g|png|webp)$/i.test(file.name));
      if(!validType||!file.size)return this.fail(photo,'Please choose a JPG, PNG or WebP image.');
      if(file.size>10*1024*1024)return this.fail(photo,'Please choose an image of 10 MB or smaller.');
    }
    return true;
  }
});
